









import { Component, Prop, Vue } from 'vue-property-decorator';
import Dialog, { ButtonType } from '@/components/Dialog.vue';
import * as Locale from '@/plugins/i18n';
import * as vtsx from 'vue-tsx-support';

interface PropTypes {
  buttons: ButtonType[];
}

@Component({
  components: {
    Dialog,
  },
})
export default class VoiceDisclaimer extends vtsx.Component<PropTypes> {
  @Prop({ default: () => ([]) }) readonly buttons!: ButtonType[]

  readonly Locale = Locale;
};
